import { combineReducers } from 'redux';

import whatsappAccount from './whatsAppAccount';

/**
 * @typedef {{
 *  whatsappAccount: import('./whatsAppAccount').DealerConfigurationIntegrationsWhatsAppAccountReducer
 * }} DealerConfigurationIntegrationsSmsProviderReducer
 */

export default combineReducers({
  whatsappAccount
});
